import React, { FunctionComponent } from 'react';
import styled, { keyframes } from 'styled-components';

type Props = {
  message?: string;
};

export const SpinnerOverlay: FunctionComponent<Props> = ({ message = 'Checking...' }) => {
  return (
    <Overlay>
      <Container>
        <Spinner />
        <Text>{message}</Text>
      </Container>
    </Overlay>
  );
};

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`;

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const Spinner = styled.div`
  border: 3px solid rgba(255, 255, 255, 0.3);
  border-top: 3px solid white;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: ${spin} 1s linear infinite;
`;

const Text = styled.div`
  color: white;
  font-size: 16px;
  font-weight: 500;
`;
